import { DtoBase } from '../../../types/Dtos/DtoBase'

export class ModifyCommentDto extends DtoBase {
  constructor(text: string) {
    super({ text })
  }
}
